import React, { lazy, Suspense } from "react";

export { default as EditContractRentList } from "./RentContract_Agent/EditContractRentList";
export { default as ListRentContract } from "./RentContract_Agent/ListRentContract";
export { default as RentPrint } from "./RentContract_Agent/RentPrint";
export { default as SecondaryForm } from "./RentContract_Agent/SecondaryForm";

export { default as EditContractSell } from "./SellContract_Agent/EditContractSell";
export { default as ListSellContract } from "./SellContract_Agent/ListSellContract";
export { default as SellPrint } from "./SellContract_Agent/SellPrint";
export { default as SellSecondaryForm } from "./SellContract_Agent/SellSecondaryForm";

const LazyListSellContract_Failed = lazy(() =>
  import("./SellContract_Agent/ListSellContract_Failed")
);
const LazyListRentContract_Failed = lazy(() =>
  import("./RentContract_Agent/ListRentContract_Failed")
);

const LazySellMainForm = lazy(() =>
  import("./SellContract_Agent/SellMain_Form")
);
const LazyMainForm = lazy(() => import("./RentContract_Agent/Main_Form"));
const LazyEditInvoce = lazy(() => import("./SellContract_Agent/EditInvoce"));
const LazyEditRentInvoice = lazy(() =>
  import("./RentContract_Agent/EditRentInvoice")
);

export const ListSellContract_Failed = () => (
  <Suspense fallback="loading...">
    <LazyListSellContract_Failed />
  </Suspense>
);
export const ListRentContract_Failed = () => (
  <Suspense fallback="loading...">
    <LazyListRentContract_Failed />
  </Suspense>
);
export const SellMain_Form = () => (
  <Suspense fallback="loading...">
    <LazySellMainForm />
  </Suspense>
);
export const Main_Form = () => (
  <Suspense fallback="loading...">
    <LazyMainForm />
  </Suspense>
);

export const EditInvoce = () => (
  <Suspense fallback="loading...">
    <LazyEditInvoce />
  </Suspense>
);
export const EditRentInvoice = () => (
  <Suspense fallback="loading...">
    <LazyEditRentInvoice />
  </Suspense>
);
